import React, { Component } from 'react';

class RestaurantSearch extends Component {
    render() {
        return (
            <div>
                <h1>Restaurant Search</h1>
            </div>
        );
    }
}

export default RestaurantSearch;